const API_URL = process.env.ROOT_API
const COMPUTE_URL = API_URL + 'computes'
const SNAPSHOT_URL = COMPUTE_URL + '/snapshots'
const KEYPAIR_URL = API_URL + 'keypairs'
const FLAVOR_URL = API_URL + 'flavors'
const IMAGE_URL = API_URL + 'images'
const USER_URL = API_URL + 'user'
const FLOATING_URL = API_URL + 'floating'
const LANG_URL = API_URL + 'locale/'
const LOGS_URL = API_URL + 'logs/'
const AUTH_URL = API_URL + 'auth/'
const REGISTER_URL = API_URL + 'register/'
const CONFIRM_URL = REGISTER_URL + 'confirm/'
const CONFIRMPAYMENT_URL = REGISTER_URL + 'crefopay'
const BILLING_URL = API_URL + 'billing'
const SECURITYGROUPS_URL = API_URL + 'security_groups'
const VOLUME_URL = API_URL + 'volumes'
const CHANGEPAYMENT_URL = REGISTER_URL + '/crefopay/paymentinstrument'

export default {
  API_URL: API_URL,
  COMPUTE_URL: COMPUTE_URL,
  SNAPSHOT_URL: SNAPSHOT_URL,
  KEYPAIR_URL: KEYPAIR_URL,
  FLAVOR_URL: FLAVOR_URL,
  IMAGE_URL: IMAGE_URL,
  USER_URL: USER_URL,
  FLOATING_URL: FLOATING_URL,
  LANG_URL: LANG_URL,
  AUTH_URL: AUTH_URL,
  LOGS_URL: LOGS_URL,
  REGISTER_URL: REGISTER_URL,
  BILLING_URL: BILLING_URL,
  SECURITYGROUPS_URL: SECURITYGROUPS_URL,
  CONFIRM_URL: CONFIRM_URL,
  CONFIRMPAYMENT_URL: CONFIRMPAYMENT_URL,
  VOLUME_URL: VOLUME_URL,
  CHANGEPAYMENT_URL: CHANGEPAYMENT_URL
}



// WEBPACK FOOTER //
// ./src/api/openstack/_const.js